import * as log from 'loglevel';
import {forEach, times, random, concat, pull, last, get, head, find, isFinite, sample} from 'lodash';
import {game} from "../../GameCore";
import {gameConfig} from "../../config/GameConfig";
import {levelGroup} from "../Level";
import {IPlatform} from 'power-patrol';
//import {createPlatform, killPlatformTiles} from './Platform';
import {IPlatformTile} from 'power-patrol';
import {getGameManager} from '../../GameManager';
import {gameState} from "../../config/GameState";
import {ILightSprite} from 'power-patrol';
import {IPlatformSet} from 'power-patrol';
import {IPlatformConfig} from 'power-patrol';
import {ILightSwitchPlatformTile} from 'power-patrol';
import {addObstacle} from '../ground/Obstacles';
import {playSound} from '../../audio/AudioManager';


export var platforms: IPlatform[];
export var platformSprites: IPlatformTile[];
export var _allowPlatforms: boolean;

var platformSet: IPlatformSet,
    endX: number;

var lightSprites: ILightSprite[];


/**
 * create a pool of platform sprites we can re-use
 */
export function createPlatformSprites()
{
    var sprite: IPlatformTile,
        shadow: Phaser.Sprite;

    //  create a group to hold platform sprites

    //platformGroup = levelGroup.addChild(game.add.group())

    platforms = platforms || [];

    platformSprites = times(40, (i: number) =>
    {
        //  create a sprite

        sprite = <IPlatformTile>game.add.sprite(150, -400, 'sprites', 'tile');

        //  enable physics on the sprite

        game.physics.arcade.enable(sprite);

        //  set sprite physics properties

        sprite.body.immovable = true;
        sprite.body.allowGravity = false;
        sprite.body.collideWorldBounds = false;

        //  add the sprite to the level group

        levelGroup.addChild(sprite);

        //  add a shadow graphic to each tile

        shadow = game.add.sprite(0, 64, 'sprites', 'tile-shadow');

        sprite.addChild(shadow);
        shadow.y = 64;

        //  return the sprite

        return sprite;
    });

    //  allow platform creation

    _allowPlatforms = true;

    //  create some sprites for our lights

    createLightSprites();
}


/**
 * create sprites for all our lightbulbs
 */
function createLightSprites()
{
    var sprite: ILightSprite;

    lightSprites = times(10, (i: number) =>
    {
        //  create a sprite

        sprite = <ILightSprite>game.add.sprite(-900, -900, 'lights', 'light-on');

        //  add the sprite to the level group

        levelGroup.addChild(sprite);

        //  set initial sprite state

        sprite.isSwitchedOn = true;
        sprite.kill();

        //  return the sprite

        return sprite;
    });
}


/**
 * reset all platforms
 */
export function resetPlatforms()
{
    //  remove all platform tile sprites

    forEach(platformSprites, (tile: Phaser.Sprite) =>
    {
        tile.reset(150, -400);
    });

    forEach(lightSprites, (sprite: ILightSprite) =>
    {
        sprite.reset(-900, -400);

        sprite.isSwitchedOn = true;
        //sprite.kill();
    });

    //  clear sprites array

    //platformSprites = [];
    platformSet = null;


    //  clear all platforms

    platforms = [];
}






/**
 * update the platforms; check existing platforms and decide whether to create any new ones
 */
export function updatePlatforms()
{
    //  is there a current platform set in play?

    if (platformSet)
    {
        //  has the group advanced far enough onto the screen?

        if (endX + levelGroup.body.x > game.world.width * 0.5) return;
    }

    if ( ! _allowPlatforms) return;

    //  if no platform set is in play, choose a set at random

    platformSet = <IPlatformSet>sample(gameConfig.level.platforms.patterns);

    //  build the set of platforms

    buildSet(platformSet);
}


/**
 * build a platform set
 * @param set
 */
function buildSet(set: IPlatformSet)
{
    var startX: number,
        switches: number,
        switchesCreated: number,
        switchWasCreated: boolean;

    //  get the starting position to build from

    startX = endX = game.world.width - levelGroup.body.x;

    //  how many switches shall we make for this set?

    switches = random(3, 5, false);
    switchesCreated = 0;

    forEach(set, (platform: IPlatformConfig) =>
    {
        let sprites: IPlatformTile[];

        sprites = getPlatformTileSprites(platform.length);

        forEach(sprites, (sprite: IPlatformTile, i: number) =>
        {
            let spriteX: number;

            //  set the tile's position

            spriteX = startX + (platform.x + i) * gameConfig.tileWidth;

            sprite.reset(spriteX, getPlatformY(platform.y));

            //  reset tile properties

            sprite.frameName = 'tile-' + random(1, 3, false);
            sprite.isSwitch = false;
            sprite.isSwitchedOn = false;

            //  save the furthest x position we've used in this set

            endX = Math.max(endX, spriteX);

            //  have we already created a switch? if so, don't create any more

            if ( ! switchWasCreated && switchesCreated < switches)
            {
                switchesCreated += createSwitch(sprite);

                switchWasCreated = true;
            }
            else
            {
                switchWasCreated = false;
            }
        })
    });

    //  add an obstacle

    addObstacle(endX + (gameConfig.tileWidth * random(3, 5, false)));
}


/**
 * convert this tile into a switch
 * @param sprite
 * @returns {number}
 */
function createSwitch(sprite: IPlatformTile) : number
{
    var createSwitch: boolean;

    //  create switches at random

    createSwitch = Math.random() > gameConfig.level.platforms.switchProbability;

    if ( ! createSwitch) return 0;

    sprite.isSwitch = true;
    sprite.isSwitchedOn = true;

    //  set tile texture

    sprite.frameName = 'switch-on';

    //  add an associated light sprite

    sprite.lightSprite = addLight(sprite.x, sprite.y);

    return 1;
}


/**
 * get a list of platform tile sprites to assign to a platform
 * @param n
 * @return {IPlatformTile[]}
 */
function getPlatformTileSprites(n: number) : IPlatformTile[]
{
    var sprites: IPlatformTile[];

    //  take n sprites from the start of the sprites list

    sprites = platformSprites.splice(0, n);

    //  replace the sprites at the end of the list

    platformSprites = concat(platformSprites, sprites);

    //  return the sprites for the new platform

    return sprites;
}


/**
 * get the y position for a platform with a given index
 * @param level
 */
function getPlatformY(level: number) : number
{
    //  return the new platform y position

    return game.world.height - gameConfig.tileWidth - (gameConfig.tileWidth * 3) * level;
}



/**
 * update all light sprites
 */
export function updateLights()
{
    forEach(lightSprites, (sprite: ILightSprite) =>
    {
        if (sprite.x + levelGroup.body.x < -gameConfig.level.lightWidth)
        {
            sprite.kill();
        }
    });
}


/**
 * toggle a switch when the player head-butts it
 * @param switchSprite
 */
export function toggleSwitch(switchSprite: IPlatformTile)
{
    //  toggle the switch

    switchSprite.frameName = 'switch-off';
    switchSprite.isSwitchedOn = false;

    //  toggle light frame

    if (switchSprite.lightSprite) switchSprite.lightSprite.frameName = 'light-off';

    //  increase the player's score

    getGameManager().incrementScore(gameConfig.game.switchBonus);

    //  display power-up effect to the user

    getGameManager().visibleBonus('+1000 points');


    //  play sound

    playSound('toggle-light-switch');
}


/**
 * get the next available light sprite
 */
function getNextLight()
{
    var light: ILightSprite;

    //  get the first item from teh array

    light = lightSprites.shift();

    lightSprites.push(light);

    return light;

    //return find(lightSprites, { alive: false });
}


/**
 * add a light to the stage
 * @param x
 * @param y
 */
export function addLight(x: number, y: number) : ILightSprite
{
    var lightSprite: ILightSprite;

    //  get the next available light sprite

    lightSprite = getNextLight();

    //log.debug('adding light sprite:', lightSprite)

    if ( ! lightSprite) return;

    //frame = game.cache.getFrameData("lights").getFrameByName("light-on");

    lightSprite.reset(x - gameConfig.level.lightWidth * 0.5 + gameConfig.tileWidth * 0.5, y - 480);

    //log.debug(x - gameConfig.level.lightWidth * 0.5 + gameConfig.tileWidth * 0.5, y - 480)

    //  set the light sprite frame

    lightSprite.frameName = 'light-on';

    //  return the light sprite

    return lightSprite;
}


/**
 * turn platforms on or off
 * @param allow
 */
export function allowPlatforms(allow: boolean)
{
    _allowPlatforms = allow;
}


// WEBPACK FOOTER //
// ./src/ts/game/level/platforms/Platforms.ts